import React from "react";

import { NO_DATA_FOUND } from "../../../../constants";

const NoteList = ({ templates, changeView, setCurrentId }) => {
  const fetchedTemplates = templates;

  return (
    <>
      {fetchedTemplates?.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      ) : (
        <div className=" note-templates w-100 px-3 mt-2">
          <table class="table mt-2 incallnotelist">
            <tbody>
              {fetchedTemplates &&
                fetchedTemplates.map((x, i) => {
                  return (
                    <tr
                      key={i}
                      onClick={() => {
                        setCurrentId(x.id);
                        changeView(2);
                      }}
                    >
                      <td>{x?.note_name?.replace(/&nbsp;/g, " ")}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default NoteList;
